<template>
    <v-container max-width="100%" style="margin-top: 2%">

      <template>
      <v-row justify="center">
        <v-dialog
          v-model="progressoDialog"
          persistent
          max-width="500"
          style="height: 300px; z-index: 90000"
        >
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <h3 style="margin-top: 20px; color: #1565c0">
                  {{ this.mensagemProgressoDialog }}
                </h3>
              </v-row>

              <v-row justify="center">
                <v-progress-circular
                  :size="50"
                  :width="5"
                  color="primary"
                  indeterminate
                  style="margin-top: 10px; margin-bottom: 10px"
                ></v-progress-circular>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  
    <v-container class="toolbar__container">
          <v-form ref="form" v-model="formValidado">
            <v-row>
              <v-col cols="12" sm="12" md="2">
                <v-autocomplete
                  v-model="idEmpresaSelected"
                  :items="empresas"
                  item-text="razao_social"
                  item-value="id_empresa"
                  clearable
                  :label="$tc('company.self', 1)"
                  @change="onEmpresaSelectChanged"
                ></v-autocomplete>
              </v-col>
              <!-- adicionar unidade -->
              <v-col cols="12" sm="6" md="3">
                <MultiplaEscolha 
                  :items="unidadesItens"
                  v-bind:selected-items.sync="unidadesSelecionadas"
                  text="descricao_unidade"
                  value="id_unidade"
                  :label="$t('nav.registration.units')"
                  :max-items="2"
                />
              </v-col>
              <!-- termina unidade -->
              <v-col cols="12" sm="4" md="3">
                <v-datetime-picker
                  :label="$t('datetime.startDate')"
                  v-model="dti"
                  :time-picker-props="timeProps"
                  :text-field-props="textFieldProps"
                  :date-picker-props="dtiProps"
                  time-format="HH:mm:ss"
                  date-format="dd/MM/yyyy"
                  :clear-text="$t('datetime.close')"
                >
                  <template slot="dateIcon">
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                  <template slot="timeIcon">
                    <v-icon>mdi-clock</v-icon>
                  </template>
                </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-datetime-picker
                :label="$t('datetime.finalDate')"
                v-model="dtf"
                :time-picker-props="timeProps"
                :text-field-props="textFieldProps"
                :date-picker-props="dtfProps"
                time-format="HH:mm:ss"
                date-format="dd/MM/yyyy"
                :clear-text="$t('datetime.close')"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
              </v-datetime-picker>
            </v-col>
            <v-col cols="12" sm="4" md="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    fab
                    color="primary darken-1"
                    class="white--text"
                    v-bind="attrs"
                    v-on="on"
                    @click="populaRelatorio"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('operation.search') }}</span>
              </v-tooltip>
            </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  v-model="idLinhaSelected"
                  :items="linhasSelect"
                  item-text="nome_linha"
                  item-value="id_linha"
                  clearable
                  multiple
                  :label="$tc('line.self', 1)"
                  @change="linhasSelectChanged"
                  :disabled="isLinhaSelectDisabled"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  v-model="idFuncionarioSelected"
                  :items="funcionariosSelect"
                  item-text="descricao"
                  item-value="id_funcionario"
                  clearable
                  multiple
                  :label="$tc('employee.self', 1)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  v-model="idVeiculoSelected"
                  :items="veiculosSelect"
                  item-text="numero_ordem"
                  item-value="id_veiculo"
                  clearable
                  multiple
                  :label="$tc('vehicle.self', 1)"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
  
  <div ref="pdfdiv">
    <merus-data-table
        :headers="headers"
        :items="viagensFiltered"
        sort-by="inicio"
        dense
        class="elevation-7"
        locale="pt"
        :loading="loadingViagens"
        :loading-text="$t('system.messages.loading')"
        style="border-radius: 10px; margin-bottom: 10px; margin-top: 10px"
        @update:displayedItems="displayedItemsForExport = $event"
    

 cod-tabela="RELTEMPODEPLACA" @update:headers="headers = $event">
        <template v-slot:toolbar>
            <CadastroToolbar
                :title="$t('relTimePlate.tripXPlateTime')"
                :token="token"
                :items="displayedItemsForExport !== null ? displayedItemsForExport : viagensFiltered"
                csv-title="tempodeplaca"
                :pdf-title="$t('relTimePlate.labelPlateTimeTrip.time')"
                :pdf-headers="headers"
                :pdf-subtitle="pdfsubtitle"
                pdf-filename="tempodeplaca"
                hide-search
            />
        </template>

        <template v-slot:item.temp_media="{ item }">
          {{ getWeatherTemp(item) }}
        </template>

        <template v-slot:item.condicao_climatica="{ item }">
          <v-icon :color="getWeatherIconColor(item)">{{ getWeatherIcon(item) }}</v-icon>
        </template>

      </merus-data-table>
    </div>
    </v-container>
  </template>
  
  <script>

  import apiController from "@/utils/apiController";
  import EventBus from "@/utils/eventBus";
  import MerusDataTable from "./Tables/MerusDataTable.vue";
  import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
  import DateUtils from "../utils/dateutils";
  import MultiplaEscolha from './Selects/MultiplaEscolha.vue';

  export default {
    components: {
    MerusDataTable,
    CadastroToolbar,
    MultiplaEscolha
},
    data: () => ({
    headers: [],
      user: null,
      token: null,
      displayedItemsForExport: null,
      progressoDialog: false,
      showConfirmButton: true,
      mensagemProgressoDialog: "",
      formValidado: false,
      loadingViagens: false,
      timeProps: {
        useSeconds: true,
      },
      dti: null,
      dtf: null,
      idEmpresaSelected:  null,
      idVeiculoSelected: [],
      idLinhaSelected: [],
      idFuncionarioSelected: [],
      isLinhaSelectDisabled: false,
      empresas: [],
      veiculos: [],
      veiculosSelect: [],
      linhas: [],
      linhasSelect: [],
      funcionarios: [],
      funcionariosSelect: [],
      unidades: [],
      unidadesSelecionadas: [],
      posicoes: [],
      viagens: [],
      viagensFiltered: [],
      isVeiculoSelectDisabled: false,
      idLinhaSelectedDisabled: false,
      config: null,
    }),
    computed: {

      textFieldProps() {
        return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
        };
      },
      headersWithProperties() {
        return this.headers.map(header => ({
          ...header,
          filtrable: true,
          sortable: true
        }));
      },
      pdfsubtitle() {
        const ordemVeiculo = this.veiculosSelect.filter((veiculo) => { return veiculo.id_veiculo === this.idVeiculoSelected }).map((v) => {
          return v.numero_ordem;
        })

        let subtitle = ""
        if (ordemVeiculo.length > 0) {
          subtitle += `${this.$tc('vehicle.self', 1)}: ${ordemVeiculo} `
        }

        if (this.idGuiaSelected) {
          const nomeGuia = this.guiasSelect.find((guia) => { return guia.id_guia === this.idGuiaSelected }).descricao_curta;
          subtitle += `|  ${this.$tc('guide.self', 1)}: ${nomeGuia}`
        }

        return subtitle;
      },
      yesterday() {
        let td = new Date();
        td.setDate(td.getDate() - 1);
        return td.toISOString().substring(0,10);
      },
      dtiProps() {
        return {
          max: this.yesterday
        }
      },
      dtfProps() {
        let min = null;
        if (this.dti) {
          if (typeof this.dti === 'string') {
            min = `${this.dti.substring(6,10)}-${this.dti.substring(3,5)}-${this.dti.substring(0,2)}`;
          } else {
            min = this.dti.toISOString().substring(0,10);
          }
        }
        return {
          min: min
        }
      },
      unidadesItens() {
        return this.unidades;
      }
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
      },
      unidadesSelecionadas() {
        if (this.idEmpresaSelected) {
          this.populaLinhasSelect(this.idEmpresaSelected);
          this.populaVeiculosSelect(this.idEmpresaSelected);
        }
        if (this.viagens.length > 0) {
          this.aplicarFiltroUnidades();
        }
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.token = sessionStorage.getItem("api");
      this.initialize();
    },
    mounted() {},
    methods: {

      idsUnidadesNoObjeto(o) {
        if (Array.isArray(o.unidades) && o.unidades.length) {
          return o.unidades.map((id) => Number(id));
        }
        if (o.id_unidade != null && o.id_unidade !== "") {
          return [Number(o.id_unidade)];
        }
        return [];
      },
      passaFiltroUnidades(o) {
        if (this.unidadesSelecionadas.length === 0) {
          return true;
        }
        const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
        return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
      },
      initialize() {
        this.getConfig();
        this.populaEmpresas();
        this.populaFuncionarios();
        this.populaLinhas();
        this.populaVeiculos();
        this.populaUnidades();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
            silent: true,
            onSuccess: (response) => {
              this.config = response.data[0];
              [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
            },
            onError: (e) => {
              console.log("Response : " + e.message);
              if (e.message == "Request failed with status code 401") {
                EventBus.$emit('show-error', { error: e });
              }
            }
          });
        },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          onSuccess: (response) => {
            this.empresas = response.data;
          }
        });
      },
      populaLinhas() {
        apiController.request(apiController.endpoints.getLinhasativas, {
          onSuccess: (response) => {
            this.linhas = response.data || [];
            if (this.idEmpresaSelected) {
              this.populaLinhasSelect(this.idEmpresaSelected);
            }
          }
        });
      },
      populaFuncionarios() {
        apiController.request(apiController.endpoints.getallFuncionarios, {
          onSuccess: (response) => {
            this.funcionarios = response.data;
          }
        });
      },
      populaVeiculos() {
        apiController.request(apiController.endpoints.getallVeiculosativos, {
          onSuccess: (response) => {
            this.veiculos = response.data || [];
            if (this.idEmpresaSelected) {
              this.populaVeiculosSelect(this.idEmpresaSelected);
            }
          }
        });
      },
      populaUnidades() {
        apiController.request(apiController.endpoints.getallUnidadesativas, {
          onSuccess: (response) => {
            this.unidades = [{ id_unidade: -1, descricao_unidade: 'Sem Unidade', cod_unidade: 'SU' }, ...(response.data || [])];
          }
        });
      },
      aplicarFiltroUnidades() {
        this.viagensFiltered = this.viagens.filter((v) => this.passaFiltroUnidades(v));
      },
      populaLinhasSelect(id_empresa) {
        let linhasFiltradas = this.linhas.filter((l) => l.id_empresa == id_empresa);
        linhasFiltradas = linhasFiltradas.filter((l) => this.passaFiltroUnidades(l));
        this.linhasSelect = linhasFiltradas;
      },
      populaVeiculosSelect(id_empresa) {
        let veiculosFiltrados = this.veiculos.filter((v) => v.id_empresa == id_empresa);
        veiculosFiltrados = veiculosFiltrados.filter((v) => this.passaFiltroUnidades(v));
        this.veiculosSelect = veiculosFiltrados;
      },
      populaFuncionariosSelect() {
        // this.funcionariosSelect = this.funcionarios.filter((f) => f.id_empresa == id_empresa);
        this.funcionariosSelect = this.funcionarios;
      },
      populaViagens() {
        this.loadingViagens = true;
        let dataInicial = DateUtils.getDateSQLFormatted(this.dti);
        let dataFinal = DateUtils.getDateSQLFormatted(this.dtf);
        let idlinhas = this.idLinhaSelected.length > 0 ? this.idLinhaSelected : this.linhasSelect.map((l) => l.id_linha);
        let idveiculos = this.idVeiculoSelected;
        let idfuncionarios = this.idFuncionarioSelected;

       
        let temp = {
          id_linha: idlinhas,
          idveiculos: idveiculos,
          idfuncionarios: idfuncionarios,
          dti: dataInicial,
          dtf: dataFinal
        }

        apiController.request(apiController.endpoints.getPrevistorealizadolinhasdata, {
          data: temp,
          onSuccess: (response) => {
            this.viagens = (response.data || []).filter((v) => v.horario_saida_realizada !== null && v.horario_chegada_realizada !== null && v.id_motorista !== null);
            this.aplicarFiltroUnidades();
            this.loadingViagens = false;
          },
          onError: () => {
            this.loadingViagens = false;
          }
        });

      },
      populaRelatorio() {
        this.$refs.form.validate();
        if (this.formValidado) {
          this.viagens = [];
          this.viagensFiltered = [];
          this.populaViagens();
          this.$nextTick(() => { this.$refs.form.resetValidation(); });
        }
      },
      linhasSelectChanged() {
      },
      getTempoPlacaTotal() {
        return this.getTempoFormatted(this.viagensFiltered.reduce((total,viagem) => total + viagem.tempo_de_placa, 0));
      },
      onEmpresaSelectChanged() {
        this.populaLinhasSelect(this.idEmpresaSelected);
        this.populaFuncionariosSelect(this.idEmpresaSelected);
        this.populaVeiculosSelect(this.idEmpresaSelected);
      },
      getWeatherIcon(item) {
        if (!item.condicao_climatica) {
          return null;
        }
        return item.condicao_climatica === this.$t('relTimePlate.rain') ? "mdi-weather-rainy" : "mdi-weather-sunny"
      },
      getWeatherIconColor(item) {
        if (!item.condicao_climatica) {
          return null;
        }
        return item.condicao_climatica === this.$t('relTimePlate.rain') ? "blue" : "orange"
      },
      getWeatherTemp(item) {
        if (!item.temp_media) {
          return null;
        }
        return `${item.temp_media} °C`;
      }
    },
  };
  </script>